import {ChangeDetectorRef, Component, Input, OnDestroy} from "@angular/core";
import {Subscription} from "rxjs";
import {GroupOrderModel} from "../group-order.model";
import {OrderModel} from "../../order/order.model";
import {GroupOrderEvents} from "../group-order-events";
import {OrderEvents} from "../../order/order-events";

@Component({
    selector: "woa-group-order-summary-icon",
    templateUrl: "./group-order-summary-icon.component.html"
})
export class GroupOrderSummaryIconComponent implements OnDestroy {
    @Input() showWithoutGroupOrder: boolean = false;
    @Input() countColorPair: string = "panel";

    participantCount: number = 0;
    hasGroupOrder: boolean = false;
    highlighted = false;

    private subscriptions: Subscription = new Subscription();

    constructor(private orderModel: OrderModel,
                private groupOrderModel: GroupOrderModel,
                private changeDetectorRef: ChangeDetectorRef) {
        this.participantCount = this.orderModel.totalTransfers;
        this.hasGroupOrder = this.groupOrderModel.hasGroupOrder;
        if (this.participantCount || this.hasGroupOrder) {
            this.highlight();
        }

        this.subscriptions.add(OrderEvents.orderChanged$.subscribe(() => {
            if (this.participantCount !== this.orderModel.totalTransfers) {
                this.participantCount = this.orderModel.totalTransfers;
                this.highlight();
            }
        }));

        this.subscriptions.add(GroupOrderEvents.groupOrderStatus$.subscribe(() => {
            if (this.hasGroupOrder !== this.groupOrderModel.hasGroupOrder) {
                this.hasGroupOrder = this.groupOrderModel.hasGroupOrder;
                if (this.hasGroupOrder) {
                    this.highlight();
                }
            }
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    highlight(): void {
        this.highlighted = true;
        this.changeDetectorRef.markForCheck();
        setTimeout(() => {
            this.highlighted = false;
            this.changeDetectorRef.markForCheck();
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./src/app/group-order/group-order-summary-icon/group-order-summary-icon.component.ts